import React, { useState, useEffect } from 'react';
import { useSession } from '@/context/SessionContext';
import LearnerLayout from '@/components/LearnerLayout';
import { Loader2, MessageSquare } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LearnerSuiviPage = () => {
  const { selectedSessionId, currentCourse } = useSession();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!selectedSessionId) { setLoading(false); return; }
    fetch(`${API}/suivi-pedagogique?course_id=${selectedSessionId}`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : { comments: [] })
      .then(d => setComments(d.comments || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [selectedSessionId]);

  const courseTitle = currentCourse?.title || 'Formation';

  return (
    <LearnerLayout>
      <div data-testid="learner-suivi-page">
        <p className="text-sm text-slate-400 mb-6">{courseTitle} - Suivi pédagogique</p>
        <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-8" data-testid="suivi-title">Suivi pédagogique</h1>

        <p className="text-slate-600 mb-6">
          Retrouvez ici les commentaires personnels envoyés par l'équipe d'intervenants de la formation.
        </p>

        {loading ? (
          <div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-blue-600" /></div>
        ) : comments.length > 0 ? (
          <div className="space-y-4">
            {comments.map((c, i) => (
              <div key={i} className="bg-white border border-slate-200 rounded-xl p-5" data-testid={`comment-${i}`}>
                <div className="flex items-center gap-2 mb-2">
                  <MessageSquare className="h-4 w-4 text-blue-600" />
                  <span className="text-sm font-semibold text-slate-900">{c.author || 'Intervenant'}</span>
                  <span className="text-xs text-slate-400">{c.date}</span>
                </div>
                <p className="text-slate-700">{c.message}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-slate-500 italic" data-testid="no-comments">Il n'y a aucun commentaire pour l'instant.</p>
        )}
      </div>
    </LearnerLayout>
  );
};

export default LearnerSuiviPage;
